import styled from '@emotion/styled';

export const StyledCard = styled('div')(
  () => `
  background: #fff;
  border-radius: 6px;
  padding: 16px;
`,
);
